import { BaseError } from '~/lib/error/base';

export class NoLoggedInUserError extends BaseError {
  constructor() {
    super({ code: 'NO_LOGGED_IN_USER', message: 'No logged-in user exists' });
  }
}
